export default "__VITE_ASSET__3d0ca5d1__"